module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 

/*
TODO: PF-2605. Hide this property for now. This should be reactivated later on during the process-
      Please DON'T REMOVE THIS.
*/


/*var checkTablet = "";
var checkPhone = "";
var textTablet = "Hide on Tablet";
var textPhone = "Hide on Phone";
if(deviceTablet.isHidden) {
    checkTablet = 'checked="true" ';}

if(devicePhone.isHidden) {
    checkPhone = 'checked="true" ';}

if (factoryKey ==='control_sound' || factoryKey ==='control_timer' ){
    textPhone= 'Do not use on Phone';
    textTablet= 'Do not use on Tablet';
}*/

    ; __append("\r\n\r\n<!--div class=\"row\" >\r\n    <div class=\"col-md-12 nopadding\">\r\n        <input id=\"isHiddenTablet\" type=\"checkbox\" name=\"isHiddenTablet\" ")
    ; __append(escapeFn( /*checkTablet*/ ))
    ; __append(">  ")
    ; __append(escapeFn( /*textTablet*/ ))
    ; __append("\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-12 nopadding\">\r\n        <input id=\"isHiddenPhone\" type=\"checkbox\" name=\"isHiddenPhone\" ")
    ; __append(escapeFn(/*checkPhone*/))
    ; __append("> ")
    ; __append(escapeFn(/*textPhone*/))
    ; __append("\r\n    </div>\r\n</div-->\r\n\r\n\r\n")
  }
  return __output;

}